import { api } from '@/services'
import qs from 'qs'

export const fetchAmount = (params) => {
  return api.post('web/appointment/calculateTotalValue', params)
}

export function batchSchedule(appointment) {
  let url = '/web/appointment/batchSchedule'
  return api.post(url, appointment)
}

export function batchPreschedule(appointment) {
  let url = '/web/appointment/batchPreschedule'
  return api.post(url, appointment)
}

export const updateVisitor = (vistorData) => {
  return api.post('web/appointment/updateVisitorData', vistorData)
}

export const updateVisitorAsAdmin = (vistorData) => {
  return api.post('admin/appointment/updateVisitorData', vistorData)
}

export const getClickSignDocumentUrl = (documentKey) => {
  return api.get(`admin/appointment/getClickSignDocumentUrl/${documentKey}`)
}

export const getClickSignDocument = (getTermFromAdminOrWeb, documentId) => {
  return api.get(`/${getTermFromAdminOrWeb}/appointment/getClickSignDocument/${documentId}`)
}

export const updateFci = (fciData) => {
  return api.post(`${fciData.isAdmin ? 'admin' : 'web'}/appointment/updateFCI`, fciData)
}

export const show = ({ id, isAdmin }) => {
  const adminPath = 'admin/appointment/details'
  const webPath = 'web/appointment/show'
  return api.get(`${isAdmin ? adminPath : webPath}/${id}`)
}

export const replaceTerm = (body, isAdmin) => {
  return api.post(`${isAdmin ? 'admin' : 'web'}/appointment/replaceTerm`, body)
}

export const addTags = (body) => {
  return api.post('web/appointment/addTags', body)
}

export const removeTags = (body) => {
  return api.post('web/appointment/removeTags', body)
}

export const getConfirmationSignatureUrl = (role, appointmentId) => {
  const endpoint = role == 'ADMIN'
    ? `/admin/appointmentFiles/confirmationSignatureDownloadUrl/${appointmentId}`
    : role === 'WEB'
      ? `/web/appointment/confirmationSignatureDownloadUrl/${appointmentId}`
      : `/web/open/appointment/confirmationSignatureDownloadUrl/${appointmentId}`

  return api.get(endpoint)
}

export const getChecklistLinkedAppointmentTypes = () => {
  return api.get('/web/appointment/checklistLinkedTypes')
}

export const fetchBaseReportCandidates = (params) => {
  return api.get('/web/appointment/baseReportCandidates', { params })
}

export const generateRealEstateAppointmentExcel = (params) => {
  return api.get('/web/appointment/createReport', {
    params,
    responseType: 'blob',
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' })
  })
}

export const listCustomerAppointmentGroup = (params) => {
  return api.get('web/appointmentGroup/list', params)
}

export const getWorkers = () => {
  return api.get('/web/appointment/workers')
}
